import {
    Input,
    Autocomplete,
    AutocompleteItem,
    DateRangePicker,
} from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate, getLocalTimeZone, today } from "@internationalized/date";

/**
 * Filter component for Initial Stock page
 * Filters: warehouse_id, search, date_from, date_to
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - warehouses: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { warehouses = [] } = filterOptions;

    // Handle clear
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    // Derive dateRange from pending
    const dateRange =
        pending.date_from && pending.date_to
            ? {
                  start: parseDate(pending.date_from),
                  end: parseDate(pending.date_to),
              }
            : null;

    // Handle date range change
    const handleDateRangeChange = (range) => {
        if (range) {
            setPending((prev) => ({
                ...prev,
                date_from: range.start.toString(),
                date_to: range.end.toString(),
            }));
        } else {
            setPending((prev) => ({
                ...prev,
                date_from: "",
                date_to: "",
            }));
        }
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Pencarian Produk */}
            <Input
                label="Cari Produk"
                placeholder="Nama produk..."
                value={pending.search || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, search: val }))
                }
                variant="flat"
                isClearable
            />

            {/* Gudang */}
            <Autocomplete
                label="Gudang"
                placeholder="Semua gudang"
                selectedKey={
                    pending.warehouse_id ? String(pending.warehouse_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        warehouse_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {warehouses.map((w) => (
                    <AutocompleteItem key={String(w.value)} value={w.value}>
                        {w.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>

            {/* Rentang Tanggal */}
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRange}
                onChange={handleDateRangeChange}
                maxValue={today(getLocalTimeZone())}
                variant="flat"
            />
        </FilterCard>
    );
};

export default FilterData;
